import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export default function MultiSelectField({ label, value, items, onChange, variant = 'standard' }) {
    // In MultiSelectField.js
    const handleChange = (event) => {
        const selected = event.target.value;
        // Pass the array directly instead of converting to string
        onChange(selected);
    }

    return (
        <FormControl sx={{ m: 1, width: 300 }}>
            {label && <InputLabel>{label}</InputLabel>}
            <Select
                multiple
                variant={variant}
                value={value ||  []} // Convert string to array
                onChange={handleChange}
                label={label} // Add label prop to Select
                renderValue={(selected) => selected.filter(Boolean).join(', ')} // Convert array to string for display
                MenuProps={MenuProps}
            >
                {items.map((item) => (
                    <MenuItem key={item} value={item}>
                        <Checkbox checked={value.includes(item)} />
                        <ListItemText primary={item} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}